import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';

import { PageHeader } from '../../../../../Components/Custom/PageHeader';

import { useMatch } from 'react-router';

import {
  Icon,
  IconArrowPolygon,
  IconCheckRanking,
  IconTier1,
  IconTier2,
  IconTier3,
  IconTier4
} from '../../../../../styles/Icons';

import { CaptionText, FooterText } from '../../../../../styles/FontStyles';

import { color } from '../../../../../styles/GlobalStyles';

import {
  ArrowTier,
  CheckboxRank,
  TierBars,
  TierCircle,
  TierReward
} from './DubaiEventStyled';

import { formatUSD } from '../../../../../helpers/helpers';

import { Col, Progress } from 'reactstrap';

import disco from '../../../../../assets/images/disco-ball.svg';

import './event.css';
import { getDubaiPromotion } from '../../slice';

export const DubaiEvent: React.FC = () => {
  const dispatch = useAppDispatch();
  const { bangkokPromotion } = useAppSelector((state) => state.userDetails);

  const match = useMatch('/users/:id/*');
  const userId = match?.params.id;

  useEffect(() => {
    dispatch(getDubaiPromotion(Number(userId)));
  }, []);

  const IconTiers = (id: number) => {
    if (id === 1) {
      return <IconTier1 />;
    } else if (id === 2) {
      return <IconTier2 />;
    } else if (id === 3) {
      return <img src={disco} alt='disco' />;
    } else if (id === 4) {
      return <IconTier4 />;
    }
  };

  const getProgressLabelPosition = (id: number) => {
    if (id === 1) {
      return { position: 'absolute', left: 0, top: -22 };
    } else if (id === 2) {
      return { position: 'absolute', right: '65%', top: -22 };
    } else if (id === 3) {
      return { position: 'absolute', right: '40%', top: -22 };
    } else if (id === 4) {
      return { position: 'absolute', right: '0', top: -22 };
    }
  };

  const getProgressWidth = (id: number) => {
    if (id === 1) {
      return '5%';
    } else if (id === 2) {
      return '20%';
    } else if (id === 3) {
      return '25%';
    } else if (id === 4) {
      return '50%';
    }
  };

  const showPersonalSalesTierAmount = (i: number, item: any) => {
    if (i === 0 && bangkokPromotion?.personalSalesAmount <= 1000) {
      return (
        <div key={i}>{formatUSD(bangkokPromotion?.personalSalesAmount)}</div>
      );
    } else if (
      i === 1 &&
      bangkokPromotion?.personalSalesAmount > 1000 &&
      bangkokPromotion?.personalSalesAmount <= 3000
    ) {
      return (
        <div key={i}>{formatUSD(bangkokPromotion?.personalSalesAmount)}</div>
      );
    } else if (
      i === 2 &&
      bangkokPromotion?.personalSalesAmount > 3000 &&
      bangkokPromotion?.personalSalesAmount <= 5000
    ) {
      return (
        <div key={i}>{formatUSD(bangkokPromotion?.personalSalesAmount)}</div>
      );
    } else if (
      i === 3 &&
      bangkokPromotion?.personalSalesAmount > 5000 &&
      bangkokPromotion?.personalSalesAmount <= 20000
    ) {
      return (
        <div key={i}>{formatUSD(bangkokPromotion?.personalSalesAmount)}</div>
      );
    } else if (
      i === 3 &&
      bangkokPromotion?.personalSalesAmount >
        item.personalSalesProgress.required
    ) {
      return (
        <div key={i}>{formatUSD(item.personalSalesProgress.required)}</div>
      );
    }
  };

  const showDirectVolumeLabelAmount = (i: number, item: any) => {
    if (i === 0 && bangkokPromotion?.personalSalesAmount <= 2000) {
      return 'label';
    } else if (
      i === 1 &&
      bangkokPromotion?.personalSalesAmount > 2000 &&
      bangkokPromotion?.personalSalesAmount <= 5000
    ) {
      return 'label';
    } else if (
      i === 2 &&
      bangkokPromotion?.personalSalesAmount > 5000 &&
      bangkokPromotion?.personalSalesAmount <= 15000
    ) {
      return 'label';
    } else if (
      i === 3 &&
      bangkokPromotion?.personalSalesAmount > 15000 &&
      bangkokPromotion?.personalSalesAmount <= 50000
    ) {
      return 'label';
    } else if (
      i === 3 &&
      bangkokPromotion?.personalSalesAmount >
        item.personalSalesProgress.required
    ) {
      return '';
    }
  };

  const showDirectVolumeTierAmount = (i: number, item: any) => {
    if (bangkokPromotion?.directVolumeAmount <= 2000 && i === 0) {
      return (
        <div key={i}>{formatUSD(bangkokPromotion?.directVolumeAmount)}</div>
      );
    } else if (
      i === 1 &&
      bangkokPromotion?.directVolumeAmount > 2000 &&
      bangkokPromotion?.directVolumeAmount <= 5000
    ) {
      return (
        <div key={i}>{formatUSD(bangkokPromotion?.directVolumeAmount)}</div>
      );
    } else if (
      i === 2 &&
      bangkokPromotion?.directVolumeAmount > 5000 &&
      bangkokPromotion?.directVolumeAmount <= 150000
    ) {
      return (
        <div key={i}>{formatUSD(bangkokPromotion?.directVolumeAmount)}</div>
      );
    } else if (
      i === 3 &&
      bangkokPromotion?.directVolumeAmount > 15000 &&
      bangkokPromotion?.directVolumeAmount <= 50000
    ) {
      return (
        <div key={i}>{formatUSD(bangkokPromotion?.directVolumeAmount)}</div>
      );
    } else if (
      i === 3 &&
      bangkokPromotion?.directVolumeAmount > item.directVolumeProgress.required
    ) {
      return <div key={i}>{formatUSD(item.directVolumeProgress.required)}</div>;
    }
  };

  const showPaidTeamTierAmount = (i: number, item: any) => {
    if (bangkokPromotion?.paidTeamAmount <= 2000 && i === 0) {
      return <div key={i}>{formatUSD(bangkokPromotion?.paidTeamAmount)}</div>;
    } else if (
      i === 1 &&
      bangkokPromotion?.paidTeamAmount > 2000 &&
      bangkokPromotion?.paidTeamAmount <= 5000
    ) {
      return <div key={i}>{formatUSD(bangkokPromotion?.paidTeamAmount)}</div>;
    } else if (
      i === 2 &&
      bangkokPromotion?.paidTeamAmount > 5000 &&
      bangkokPromotion?.paidTeamAmount <= 15000
    ) {
      return <div key={i}>{formatUSD(bangkokPromotion?.paidTeamAmount)}</div>;
    } else if (
      i === 3 &&
      bangkokPromotion?.paidTeamAmount > 15000 &&
      bangkokPromotion?.paidTeamAmount <= 50000
    ) {
      return <div key={i}>{formatUSD(bangkokPromotion?.paidTeamAmount)}</div>;
    } else if (
      i === 3 &&
      bangkokPromotion?.paidTeamAmount > item.paidTeamProgress.required
    ) {
      return <div key={i}>{formatUSD(item.paidTeamProgress.required)}</div>;
    }
  };

  const showPaidTeamLabelAmount = (i: number, item: any) => {
    if (i === 0 && bangkokPromotion?.personalSalesAmount <= 2000) {
      return 'label';
    } else if (
      i === 1 &&
      bangkokPromotion?.personalSalesAmount > 2000 &&
      bangkokPromotion?.personalSalesAmount <= 5000
    ) {
      return 'label';
    } else if (
      i === 2 &&
      bangkokPromotion?.personalSalesAmount > 5000 &&
      bangkokPromotion?.personalSalesAmount <= 15000
    ) {
      return 'label';
    } else if (
      i === 3 &&
      bangkokPromotion?.personalSalesAmount > 15000 &&
      bangkokPromotion?.personalSalesAmount <= 50000
    ) {
      return 'label';
    } else if (
      i === 3 &&
      bangkokPromotion?.personalSalesAmount >
        item.personalSalesProgress.required
    ) {
      return '';
    }
  };

  const showLabelAmount = (i: number, item: any) => {
    if (i === 0 && bangkokPromotion?.personalSalesAmount <= 1000) {
      return 'label';
    } else if (
      i === 1 &&
      bangkokPromotion?.personalSalesAmount > 1000 &&
      bangkokPromotion?.personalSalesAmount <= 3000
    ) {
      return 'label';
    } else if (
      i === 2 &&
      bangkokPromotion?.personalSalesAmount > 3000 &&
      bangkokPromotion?.personalSalesAmount <= 5000
    ) {
      return 'label';
    } else if (
      i === 3 &&
      bangkokPromotion?.personalSalesAmount > 5000 &&
      bangkokPromotion?.personalSalesAmount <= 20000
    ) {
      return 'label';
    } else if (
      i === 3 &&
      bangkokPromotion?.personalSalesAmount >
        item.personalSalesProgress.required
    ) {
      return '';
    }
  };

  interface HasConditionProps {
    hasCondition: boolean;
  }

  const IconArrow: React.FC<HasConditionProps> = ({ hasCondition }) => {
    return (
      <Icon
        style={{ transform: 'rotate(270deg)' }}
        color={hasCondition ? '#4830C1' : '#A9A9A9'}>
        <IconArrowPolygon />
      </Icon>
    );
  };

  return (
    <Col lg={12}>
      <div className='d-flex justify-content-lg-around mb-5'>
        <div>
          <h6>PROMOTION STARTS</h6>
          <h6 style={{ fontWeight: 'bold' }}>April 8, 2025, 00:00 UTC</h6>
        </div>
        <div>
          <h6>PROMOTION ENDS</h6>
          <h6 style={{ fontWeight: 'bold' }}>April 28, 2024, 23:59 UTC</h6>
        </div>
        <div>
          <h6>VALID</h6>
          <h6 style={{ fontWeight: 'bold' }}>20 days</h6>
        </div>
      </div>
      {/* <div>
        <h6>REWARDS</h6>

        {bangkokPromotion?.tiers?.map((item, i) => {
          return (
            <TierReward
              color={item.hasConditionForTier ? '#4830C1' : '#A9A9A9'}
              key={i}>
              <span>
                <Icon>{IconTiers(i + 1)}</Icon>
              </span>
              <div
                style={{
                  color: item.hasConditionForTier ? '#4830C1' : '#A9A9A9'
                }}>
                {item.name} - {item.reward}
              </div>
              {item.hasConditionForTier && (
                <CheckboxRank color={'#4830C1'}>
                  <Icon color={'#FFFFFF'} size='10px'>
                    <IconCheckRanking />
                  </Icon>
                </CheckboxRank>
              )}
            </TierReward>
          );
        })}

        <div
          style={{
            display: 'flex',
            marginTop: '50px',
            alignItems: 'center',
            position: 'relative',
            height: 100
          }}>
          <div
            style={{
              position: 'absolute',
              left: 'calc(5% - 22px)',
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column'
            }}>
            <TierCircle
              color={
                bangkokPromotion?.tiers &&
                bangkokPromotion?.tiers[0]?.hasConditionForTier
                  ? '#4830C1'
                  : '#A9A9A9'
              }>
              <Icon>{IconTiers(1)}</Icon>
            </TierCircle>
            <PageHeader title='Tier 1' />
          </div>
          <div
            style={{
              position: 'absolute',
              left: 'calc(25% - 22px)',
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column'
            }}>
            <TierCircle
              color={
                bangkokPromotion?.tiers &&
                bangkokPromotion?.tiers[1]?.hasConditionForTier
                  ? '#4830C1'
                  : '#A9A9A9'
              }>
              <Icon>{IconTiers(2)}</Icon>
            </TierCircle>
            <PageHeader title='Tier 2' />
          </div>
          <div
            style={{
              position: 'absolute',
              left: 'calc(50% - 22px)',
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column'
            }}>
            <TierCircle
              color={
                bangkokPromotion?.tiers &&
                bangkokPromotion?.tiers[2]?.hasConditionForTier
                  ? '#4830C1'
                  : '#A9A9A9'
              }>
              <Icon>{IconTiers(3)}</Icon>
            </TierCircle>
            <PageHeader title='Tier 3' />
          </div>
          <div
            style={{
              position: 'absolute',
              left: 'calc(95% - 22px)',
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column'
            }}>
            <TierCircle
              color={
                bangkokPromotion?.tiers &&
                bangkokPromotion?.tiers[3]?.hasConditionForTier
                  ? '#4830C1'
                  : '#A9A9A9'
              }>
              <Icon>{IconTiers(4)}</Icon>
            </TierCircle>
            <PageHeader title='Tier 4' />
          </div>
          <ArrowTier
            style={{
              position: 'absolute',
              left: 'calc(5% + 10px)',
              right: 'calc(75% + 10px)'
            }}
            hasCondition={
              bangkokPromotion?.tiers &&
              bangkokPromotion?.tiers[0]?.hasConditionForTier
            }></ArrowTier>
          <ArrowTier
            style={{
              position: 'absolute',
              left: 'calc(25% + 10px)',
              right: 'calc(50% + 10px)'
            }}
            hasCondition={
              bangkokPromotion?.tiers &&
              bangkokPromotion?.tiers[1]?.hasConditionForTier
            }
          />
          <ArrowTier
            style={{
              position: 'absolute',
              left: 'calc(50% + 10px)',
              right: 'calc(95% + 10px)',
              width: 'calc(45% - 60px)'
            }}
            hasCondition={
              bangkokPromotion?.tiers &&
              bangkokPromotion?.tiers[2].hasConditionForTier
            }
          />
          <div
            style={{
              position: 'absolute',
              right: 'calc(75%  + 20px)'
            }}>
            <IconArrow
              hasCondition={
                bangkokPromotion?.tiers &&
                bangkokPromotion?.tiers[0]?.hasConditionForTier
              }
            />
          </div>
          <div
            style={{
              position: 'absolute',
              right: 'calc(50%  + 20px)'
            }}>
            <IconArrow
              hasCondition={
                bangkokPromotion?.tiers &&
                bangkokPromotion?.tiers[1]?.hasConditionForTier
              }
            />
          </div>
          <div
            style={{
              position: 'absolute',
              right: 'calc(5%  + 20px)'
            }}>
            <IconArrow
              hasCondition={
                bangkokPromotion?.tiers &&
                bangkokPromotion?.tiers[2]?.hasConditionForTier
              }
            />
          </div>
        </div>
      </div> */}
      <CaptionText caps mb='12' mt='50'>
        Track your progress
      </CaptionText>
      <h6 className='mb-3'> Personal Sales</h6>
      <CaptionText color={color.colors.neutral900} mb='32'>
        Current: {formatUSD(bangkokPromotion?.personalSalesAmount)} USDT
      </CaptionText>
      <div style={{ position: 'relative' }}>
        {bangkokPromotion?.tiers?.map((item, i) => {
          return (
            <FooterText
              key={i}
              style={getProgressLabelPosition(i + 1)}
              color={color.colors.neutral700}>
              Required: {formatUSD(item.personalSalesProgress.required)} USDT
            </FooterText>
          );
        })}
      </div>
      <TierBars>
        {bangkokPromotion?.tiers?.map((item: any, i: number) => {
          return (
            <>
              <div style={{ width: getProgressWidth(i + 1) }}>
                <Progress
                  value={item.personalSalesProgress.percentage}
                  color={'success'}
                  className='animated-progess custom-progess progress-label'>
                  <div
                    className={showLabelAmount(i, item)}
                    style={{
                      backgroundColor: '#09B29C'
                    }}>
                    {showPersonalSalesTierAmount(i, item)}
                  </div>
                </Progress>
              </div>
            </>
          );
        })}
      </TierBars>
      <h6 className='mb-3 mt-5'>Unilevel Volume</h6>
      <CaptionText color={color.colors.neutral900} mb='32'>
        Current: {formatUSD(bangkokPromotion?.directVolumeAmount)} USDT
      </CaptionText>
      <div style={{ position: 'relative' }}>
        {bangkokPromotion?.tiers?.map((item, i) => {
          return (
            <FooterText
              key={i}
              style={getProgressLabelPosition(i + 1)}
              color={color.colors.neutral700}>
              Required: {formatUSD(item.directVolumeProgress.required)} USDT
            </FooterText>
          );
        })}
      </div>
      <TierBars>
        {bangkokPromotion?.tiers?.map((item: any, i: number) => {
          return (
            <>
              <div style={{ width: getProgressWidth(i + 1) }}>
                <Progress
                  value={item.directVolumeProgress.percentage}
                  color={'success'}
                  className='animated-progess custom-progess progress-label'>
                  <div
                    className={showDirectVolumeLabelAmount(i, item)}
                    style={{
                      backgroundColor: '#09B29C'
                    }}>
                    {showDirectVolumeTierAmount(i, item)}
                  </div>
                </Progress>
              </div>
            </>
          );
        })}
      </TierBars>
      <h6 className='mb-3 mt-5'>Weaker Leg Volume</h6>
      <CaptionText color={color.colors.neutral900} mb='32'>
        Current: {formatUSD(bangkokPromotion?.paidTeamAmount)} USDT
      </CaptionText>
      <div style={{ position: 'relative' }}>
        {bangkokPromotion?.tiers?.map((item, i) => {
          return (
            <FooterText
              key={i}
              style={getProgressLabelPosition(i + 1)}
              color={color.colors.neutral700}>
              Required: {formatUSD(item.paidTeamProgress.required)} USDT
            </FooterText>
          );
        })}
      </div>
      <TierBars>
        {bangkokPromotion?.tiers?.map((item, i) => {
          return (
            <>
              <div style={{ width: getProgressWidth(i + 1) }}>
                <Progress
                  value={item.paidTeamProgress.percentage}
                  color={'success'}
                  className='animated-progess custom-progess progress-label'>
                  <div
                    className={showPaidTeamLabelAmount(i, item)}
                    style={{
                      backgroundColor: '#09B29C'
                    }}>
                    {showPaidTeamTierAmount(i, item)}
                  </div>
                </Progress>
              </div>
            </>
          );
        })}
      </TierBars>
    </Col>
  );
};
